"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideMenuButtonItemsWithFn = exports.SESSION_TIMEOUT = exports.SERVICE_LOGS_TYPE = exports.ROLE_MAP_TO_USER = exports.NEW_ALERT_MAP = exports.LOGOUT_TIMEOUT = exports.ArraytoObj = exports.ALERT_ICONS_MAP = void 0;
exports.bindAddress = bindAddress;
exports.checkOnboardingFlag = checkOnboardingFlag;
exports.getMessageForBrowser = exports.getDate = exports.generateUuid = exports.formatTimeDateString = exports.formatDateString = exports.fetchStoreSystem = exports.fetchImage = exports.extractNumberFromString = exports.detectCamera = exports.createAlertList = exports.convertToBase64 = void 0;
exports.getNavItems = getNavItems;
exports.getPasswordConditionCheckColor = getPasswordConditionCheckColor;
exports.getPlatformType = exports.getPersonaName = void 0;
exports.getReactEnv = getReactEnv;
exports.getRoleType = getRoleType;
exports.headerHeight = exports.handleSensorTimeout = exports.groupLogs = exports.groupData = exports.groupByDate = exports.getYear = exports.getUserTypeFromGroup = exports.getUserTypeForDispatcherLayout = exports.getSystemsData = exports.getStoresInfo = exports.getStoreListItems = void 0;
exports.isJSON = isJSON;
exports.isObject = exports.isJsonString = void 0;
exports.isSessionTimeout = isSessionTimeout;
exports.numberOfDays = exports.mapAlertItemToArray = exports.manageAlertData = exports.logoutChannel = exports.loginChannel = exports.isTimeDifference24Hours = void 0;
exports.onChangeHandler = onChangeHandler;
exports.updateAlertItemArrayInRedux = exports.sortObj = exports.sortAlphaNumericArray = exports.setUserDetails = exports.setStoreAndGateway = exports.setNotifyPref = exports.setDeleteSystemState = exports.setAlarmSeveritySign = exports.setAlarmSeverityColor = exports.removeSystem = exports.remainingFilterLife = exports.parseAddress = void 0;
exports.validateEmail = validateEmail;
exports.waterInfoMap = void 0;
var _react = _interopRequireDefault(require("react"));
var _awsAmplify = require("aws-amplify");
var _lodash = require("lodash");
var _images = require("../assets/images");
var _strings = require("./strings");
var _RoutePath = _interopRequireDefault(require("../../RoutePath"));
var _moment = _interopRequireDefault(require("moment"));
var _Services = require("./Services");
var _alertReducer = require("../redux/reducers/alertReducer");
var _systemsReducer = require("../redux/reducers/systemsReducer");
var _gatewayReducer = require("../redux/reducers/gatewayReducer");
var _storesReducer = require("../redux/reducers/storesReducer");
var _bowser = _interopRequireDefault(require("bowser"));
var _WebSocketManager = _interopRequireDefault(require("../../common_features/utility/WebSocketManager"));
var _event = require("../../common_features/utility/event");
var _broadcastChannel = require("broadcast-channel");
var _strings2 = require("../../common_features/utility/strings");
const {
  v4: uuidv4
} = require("uuid");
const SESSION_TIMEOUT = exports.SESSION_TIMEOUT = 25 * 60 * 1000; // in milli secs = 60 sec
const LOGOUT_TIMEOUT = exports.LOGOUT_TIMEOUT = 5 * 60 * 1000; // in miilli = 60 sec
const logoutChannel = exports.logoutChannel = new _broadcastChannel.BroadcastChannel('logout');
const loginChannel = exports.loginChannel = new _broadcastChannel.BroadcastChannel('login');
const ROLE_MAP_TO_USER = exports.ROLE_MAP_TO_USER = {
  "1": "superadmin",
  "2": "admin",
  "3": "twm",
  "4": "owner",
  "5": "dispatcher",
  "6": "manager",
  "7": "technician"
};
const ALERT_ICONS_MAP = exports.ALERT_ICONS_MAP = {
  "1": _images.High.default,
  "2": _images.High.default,
  "3": _images.lowIcon.default,
  "4": _images.Info.default,
  "5": _images.Low.default
};
const NEW_ALERT_MAP = exports.NEW_ALERT_MAP = {
  "info": _images.Info.default,
  "wran": _images.Medium.default,
  "error": _images.High.default
};
const headerHeight = exports.headerHeight = "80px";
function getNavItems(_ref) {
  let {
    currentRole,
    SideMenuButtonItems
  } = _ref;
  const roleName = ROLE_MAP_TO_USER[currentRole];
  const filtered = SideMenuButtonItems.map(itemsList => {
    return itemsList.filter(item => item.visibleTo[roleName]);
  });
  return filtered;
}
function onChangeHandler(e, dispatch) {
  const type = (0, _lodash.get)(e, 'target.type', null);
  switch (type) {
    case 'text':
    case 'password':
      dispatch(e.target.value);
      break;
    case 'checkbox':
      dispatch(e.target.checked);
      break;
    default:
      // console.log("Type not supported", e.target.type)
      dispatch(e);
      break;
  }
}
function isSessionTimeout() {
  const active = localStorage && localStorage.getItem('lastActive');
  return active && (0, _moment.default)().valueOf() > parseInt(active, 10);
}
function getReactEnv() {
  let env = process.env.REACT_APP_ENV;
  if (!env) {
    env = 'dev';
  }
  return env;
}
function validateEmail(emailAddress) {
  var _emailAddress$trim;
  const email = (emailAddress === null || emailAddress === void 0 ? void 0 : (_emailAddress$trim = emailAddress.trim) === null || _emailAddress$trim === void 0 ? void 0 : _emailAddress$trim.call(emailAddress)) || '';
  return email && _strings.VALIDATION_REGX.email.test(email) || false;
}
function getPasswordConditionCheckColor(value) {
  if (value) {
    return 'rgb(110, 183, 11)';
  } else {
    return '#BFC1C4';
  }
}
function isJSON(text) {
  if (typeof text !== "string") {
    return false;
  }
  try {
    JSON.parse(text);
    return true;
  } catch (error) {
    return false;
  }
}
const getAddressDetails = (keys, counter, acc, json, add) => {
  return keys.length === counter ? acc + json[add] : acc;
};
function bindAddress(json) {
  let countries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const keys = Object.keys(json);
  let counter = 0;
  return keys.reduce((acc, add) => {
    counter = counter + 1;
    if (add === 'country' && countries.length) {
      let currentCountry = [...countries].filter(cnt => cnt.code === json[add])[0];
      if (!currentCountry) {
        return keys.length !== counter ? acc + json[add] + ", " : acc + json[add];
      }
      let newCountry = currentCountry.title;
      return keys.length !== counter ? acc + newCountry + ", " : acc + newCountry;
    }
    return json[add] && keys.length !== counter ? acc + json[add] + ", " : getAddressDetails(keys, counter, acc, json, add);
  }, [""]);
}
function getRoleType(userType) {
  let roleTypeValue;
  switch (userType) {
    case "pentair_org_owner_group":
      roleTypeValue = 4;
      break;
    case "pentair_sp_dispatcher_group":
      roleTypeValue = 5;
      break;
    case "pentair_sp_technician_group":
      roleTypeValue = 7;
      break;
    case "pentair_store_manager_group":
      roleTypeValue = 6;
      break;
    default:
      roleTypeValue = -1;
      break;
  }
  return roleTypeValue;
}
const getPlatformType = () => {
  const value = _bowser.default.parse(navigator.userAgent).platform.type;
  return value === "desktop" || false;
};
exports.getPlatformType = getPlatformType;
const getUserTypeForDispatcherLayout = (userInfo, personaDetails) => {
  const personaSetter = {
    0: () => personaDetails.userTypeType = 0,
    6: () => personaDetails.userTypeType = 6,
    7: () => personaDetails.userTypeType = 7
  };
  const personaGetter = personaSetter[userInfo.userType] || personaSetter[0];
  personaGetter();
  return personaDetails;
};
exports.getUserTypeForDispatcherLayout = getUserTypeForDispatcherLayout;
const getPersonaName = (userInfo, personaDetails) => {
  const personaSetter = {
    4: () => personaDetails.personaName = "Owner",
    5: () => personaDetails.personaName = "Dispatcher",
    6: () => personaDetails.personaName = "Employee",
    7: () => personaDetails.personaName = "Technician"
  };
  const personaGetter = personaSetter[userInfo.userType];
  personaGetter();
};
exports.getPersonaName = getPersonaName;
const isJsonString = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};
exports.isJsonString = isJsonString;
const parseAddress = address => {
  let newAddress;
  if (address && isJSON(address)) {
    const addressObj = JSON.parse(address);
    newAddress = {
      postalcode: addressObj.postalcode || addressObj.zip,
      address1: addressObj.address1,
      address2: addressObj.address2,
      country: addressObj.country,
      state: addressObj.state,
      city: addressObj.city,
      phoneNo: addressObj.phoneNo,
      zipcode: addressObj.zipcode
    };
    return newAddress;
  }
  return address;
};
exports.parseAddress = parseAddress;
function checkOnboardingFlag(onboarding_flag) {
  switch (onboarding_flag) {
    case "0":
      return _RoutePath.default.createProfile.useLink /* '/CreateProfile' */;
    case "1":
      return _RoutePath.default.NotificationPreferencesOnboard.useLink /* '/NotificationPreferences during creating profile' */;
    case "2":
      return _RoutePath.default.admin.path;
    default:
      return null;
  }
}
const getUserTypeFromGroup = function () {
  let group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'pentair_org_owner_group';
  const typeString = Object.keys(_strings.USER_GROUP).find(key => _strings.USER_GROUP[key] === group);
  return _strings.OWNER_USER_TYPES[typeString];
};
exports.getUserTypeFromGroup = getUserTypeFromGroup;
const getDate = date => {
  let systemDate = new Date(date);
  let convertedSystemDate = (systemDate.getMonth() > 8 ? systemDate.getMonth() + 1 : '0' + (systemDate.getMonth() + 1)) + '/' + (systemDate.getDate() > 9 ? systemDate.getDate() : '0' + systemDate.getDate()) + '/' + systemDate.getFullYear();
  return convertedSystemDate;
};
exports.getDate = getDate;
const numberOfDays = (accessoryLife, date) => {
  let expiryDate = (0, _moment.default)(date).add(getYear(accessoryLife, date), 'days');
  let currentdate = (0, _moment.default)();
  let days = expiryDate.diff(currentdate, 'days');
  return days;
};
exports.numberOfDays = numberOfDays;
const getYear = (accessoryLife, date) => {
  let yearvalue = (0, _moment.default)(date).year();
  let daysOfAccessoryLife = accessoryLife / 12;
  let totalYearDays = 0;
  if (yearvalue % 4 === 0) {
    totalYearDays = 366 * daysOfAccessoryLife;
  } else {
    totalYearDays = 365 * daysOfAccessoryLife;
  }
  return totalYearDays;
};
exports.getYear = getYear;
const remainingFilterLife = (accessoryLife, date) => {
  let expiryDate = (0, _moment.default)(date).add(getYear(accessoryLife, date), 'days');
  let currentdate = (0, _moment.default)();
  let months = expiryDate.diff(currentdate, 'months');
  let weeks = expiryDate.diff(currentdate, 'weeks');
  let days = expiryDate.diff(currentdate, 'days');
  let value = 0;
  if (months > 0 && months <= 24) {
    value = months === 1 ? months + " month remaining" : months + " months remaining";
  } else if (weeks > 0 && weeks < 5) {
    value = weeks === 1 ? weeks + " week remaining" : weeks + " weeks remaining";
  } else if (days > 0) {
    value = days === 1 ? days + " day remaining" : days + " days remaining";
  } else {
    value = days <= 0 && "0 day remaining";
  }
  return value;
};
exports.remainingFilterLife = remainingFilterLife;
const ArraytoObj = arrOfObj => {
  const arraytoObj = {};
  arrOfObj.forEach(item => {
    arraytoObj[item.severity] = item.count;
  });
  return arraytoObj;
};
exports.ArraytoObj = ArraytoObj;
const setAlarmList = (alm, list1, list2, list3) => {
  const setterAlarm = {
    1: () => list1[alm.id] = alm,
    2: () => list2[alm.id] = alm,
    3: () => list3[alm.id] = alm
  };
  const getter = setterAlarm[alm.severity];
  return getter();
};
const createAlertList = (type, data) => {
  const list1 = {};
  const list2 = {};
  const list3 = {};
  switch (type) {
    case "device":
      data.forEach(item => {
        var _item$alarms;
        item === null || item === void 0 ? void 0 : (_item$alarms = item.alarms) === null || _item$alarms === void 0 ? void 0 : _item$alarms.forEach(alm => {
          alm.deviceId = item.deviceId;
          alm.read = false;
          alm.type = "PRODUCT";
          setAlarmList(alm, list1, list2, list3);
        });
      });
      break;
    case "systems":
      data.forEach(item => {
        var _item$alarms2;
        item === null || item === void 0 ? void 0 : (_item$alarms2 = item.alarms) === null || _item$alarms2 === void 0 ? void 0 : _item$alarms2.forEach(alm => {
          alm.systemId = item.systemId;
          alm.read = false;
          alm.type = "PRODUCT";
          setAlarmList(alm, list1, list2, list3);
        });
      });
      break;
    default:
      return;
  }
  return {
    list1,
    list2,
    list3
  };
};
exports.createAlertList = createAlertList;
const manageAlertData = data => {
  var _newData$severityCoun, _newData$systems, _newData$deviceAlarms;
  let newData = {
    ...data,
    listItems: {}
  };
  if (newData !== null && newData !== void 0 && (_newData$severityCoun = newData.severityCounts) !== null && _newData$severityCoun !== void 0 && _newData$severityCoun.length) {
    newData.severityCounts = ArraytoObj(newData.severityCounts);
  }
  let listSystem = {};
  let listDevice = {};
  if (newData !== null && newData !== void 0 && (_newData$systems = newData.systems) !== null && _newData$systems !== void 0 && _newData$systems.length) {
    listSystem = createAlertList("systems", newData.systems);
  }
  if (newData !== null && newData !== void 0 && (_newData$deviceAlarms = newData.deviceAlarms) !== null && _newData$deviceAlarms !== void 0 && _newData$deviceAlarms.length) {
    listDevice = createAlertList("device", newData.deviceAlarms);
  }
  newData.listItems = {
    ...listSystem.list1,
    ...listDevice.list1,
    ...listSystem.list2,
    ...listDevice.list2,
    ...listSystem.list3,
    ...listDevice.list3
  };
  return newData;
};
exports.manageAlertData = manageAlertData;
const setAlarmSeveritySign = val => {
  let warningLogo = "";
  const signSetter = {
    0: () => warningLogo = "info",
    1: () => warningLogo = "error",
    2: () => warningLogo = "error",
    3: () => warningLogo = "error",
    4: () => warningLogo = "info"
  };
  const signGetter = signSetter[val] || signSetter[0];
  signGetter();
  return warningLogo;
};
exports.setAlarmSeveritySign = setAlarmSeveritySign;
const setAlarmSeverityColor = val => {
  let warningColor = "";
  const signSetter = {
    "error": () => warningColor = "#E00932",
    "wran": () => warningColor = "#FA6400",
    "info": () => warningColor = "#0B3471",
    "0": () => warningColor = ""
  };
  const signGetter = signSetter[val] || signSetter["0"];
  signGetter();
  return warningColor;
};
exports.setAlarmSeverityColor = setAlarmSeverityColor;
const formatDateString = dt => {
  return dt.toLocaleDateString(undefined, {
    month: "short",
    day: '2-digit',
    year: 'numeric'
  });
};
exports.formatDateString = formatDateString;
const formatTimeDateString = date => {
  const timestamp = new Date(date);
  const options = {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric'
  };
  const formattedDateTime = timestamp.toLocaleDateString(undefined, options);
  return formattedDateTime;
};
exports.formatTimeDateString = formatTimeDateString;
const mapAlertItemToArray = (arr, alarm) => {
  return [...arr, {
    id: alarm.id,
    variant: "tile",
    isRead: alarm.isRead,
    noBoarder: true,
    fullWidth: true,
    optionBtnTitle: "Learn More",
    wrapperStyle: {
      paddingLeft: "0px",
      paddingRight: "0px",
      border: "1px solid rgba(0,0,0,0.1)"
    },
    alertMessageType: setAlarmSeveritySign(alarm.severity),
    alertText: alarm.alarmText.alertTitle,
    Description: alarm.alarmText.alert_details,
    data: alarm.createdAt,
    type: alarm.type,
    alertImageLeft: ALERT_ICONS_MAP[alarm.severity]
  }];
};
exports.mapAlertItemToArray = mapAlertItemToArray;
const updateAlertItemArrayInRedux = (alertData, systemData) => {
  var _alertData$systems;
  alertData === null || alertData === void 0 ? void 0 : (_alertData$systems = alertData.systems) === null || _alertData$systems === void 0 ? void 0 : _alertData$systems.forEach(element => {
    if (element.systemId === systemData.systemId) {
      var _element$alarms;
      let arr = [];
      element === null || element === void 0 ? void 0 : (_element$alarms = element.alarms) === null || _element$alarms === void 0 ? void 0 : _element$alarms.forEach((alarm, i) => {
        arr = mapAlertItemToArrayForGateways(arr, alarm, i);
      });
      systemData.item = arr;
    }
  });
  return systemData;
};
exports.updateAlertItemArrayInRedux = updateAlertItemArrayInRedux;
const mapAlertItemToArrayForGateways = (arr, alarm, i) => {
  /* Currently we can have max of 4 alerts at a time. */
  if (i < 4) {
    arr = mapAlertItemToArray(arr, alarm);
  }
  return arr;
};
const processAlertsOnSystemGateways = (type, newData, data) => {
  switch (type) {
    case 'systems':
      newData.systems.forEach(element => {
        data.forEach(sys => {
          if (element.systemId === sys.systemId) {
            let arr = [];
            element.alarms.forEach((alarm, i) => {
              arr = mapAlertItemToArrayForGateways(arr, alarm, i);
            });
            sys.item = arr;
          }
        });
      });
      break;
    case 'gateways':
      newData.deviceAlarms.forEach(element => {
        data.forEach(gtwy => {
          if (element.deviceId === gtwy.deviceId) {
            let arr = [];
            element.alarms.forEach((alarm, i) => {
              arr = mapAlertItemToArrayForGateways(arr, alarm, i);
            });
            gtwy.item = arr;
          }
        });
      });
      break;
  }
  return data;
};
const fetchStoreSystem = async (storeId, store, dispatch, setStoreAlertCount, userType) => {
  await (0, _Services.getStoreSystems)(storeId).then(async data => {
    var _newData, _newData2, _newData3;
    let {
      systems,
      gateways
    } = data.data;
    let newData = null;
    await (0, _Services.getAlerts)(storeId).then(res => {
      if (res.success) {
        newData = manageAlertData(res.data);
        dispatch((0, _alertReducer.alertData)({
          storeId,
          data: {
            ...newData,
            ...store
          }
        }));
        processAlertsOnSystemGateways('systems', newData, systems);
        processAlertsOnSystemGateways('gateways', newData, gateways);
        const payload = {
          storeId: storeId,
          data: {
            ...newData,
            ...store
          }
        };
        dispatch((0, _alertReducer.alertData)(payload));
      }
    }).catch(e => {
      return e;
    });
    let storeAlertCountObj = [];
    if ((_newData = newData) !== null && _newData !== void 0 && _newData.severityCounts[1]) {
      storeAlertCountObj.push({
        type: "error",
        count: newData.severityCounts[1],
        icon: ALERT_ICONS_MAP[1]
      });
    }
    if ((_newData2 = newData) !== null && _newData2 !== void 0 && _newData2.severityCounts[2]) {
      storeAlertCountObj.push({
        type: "error",
        count: newData.severityCounts[2],
        icon: ALERT_ICONS_MAP[2]
      });
    }
    if ((_newData3 = newData) !== null && _newData3 !== void 0 && _newData3.severityCounts[3]) {
      storeAlertCountObj.push({
        type: "error",
        count: newData.severityCounts[3],
        icon: ALERT_ICONS_MAP[3]
      });
    }
    setStoreAlertCount(storeAlertCountObj);
    userType ? dispatch((0, _systemsReducer.systemsInfo)(systems.filter(obj => obj.isComplete === true))) : dispatch((0, _systemsReducer.systemsInfo)(systems));
    dispatch((0, _gatewayReducer.gatewayInfo)(gateways));
  });
  return null;
};
exports.fetchStoreSystem = fetchStoreSystem;
const getStoreListItems = async (dispatch, storesInfo) => {
  var _storeList$data, _storeList$data$rows, _storeList$data2;
  const storeList = await (0, _Services.getStores)();
  const data = storeList !== null && storeList !== void 0 && (_storeList$data = storeList.data) !== null && _storeList$data !== void 0 && (_storeList$data$rows = _storeList$data.rows) !== null && _storeList$data$rows !== void 0 && _storeList$data$rows.length ? storeList === null || storeList === void 0 ? void 0 : (_storeList$data2 = storeList.data) === null || _storeList$data2 === void 0 ? void 0 : _storeList$data2.rows : [];
  let newdatawithAlarm = data.filter(item => item.AlarmCount).map(store => {
    var _store$AlarmCount;
    if (store !== null && store !== void 0 && (_store$AlarmCount = store.AlarmCount) !== null && _store$AlarmCount !== void 0 && _store$AlarmCount.length) {
      store.AlarmCount.forEach(row => {
        if (row.severity === 1) {
          store.error = row.count;
        } else if (row.severity === 2) {
          store.error = row.count;
        } else if (row.severity === 3) {
          store.error = row.count;
        }
      });
    }
    return store;
  });
  console.log(newdatawithAlarm);
  let newdatawithOutAlarm1 = data.filter(item => !item.AlarmCount);
  let newdata = newdatawithAlarm;
  dispatch(storesInfo([...newdata, ...newdatawithOutAlarm1]));
};
exports.getStoreListItems = getStoreListItems;
const clickedStyle = {
  backgroundColor: '#F0F8FE',
  borderLeft: '6px solid  #0B3471',
  height: '60px',
  width: '250px',
  justifyContent: 'center'
};
const notClickedStyle = {
  height: '60px',
  width: '240px',
  justifyContent: 'center'
};
const commonStyle = {
  fontSize: '1em',
  fontWeight: 600,
  lineHeight: '22px',
  width: '200px',
  fontFamily: 'Poppins',
  color: '#333',
  left: 0,
  marginTop: '40px',
  padding: 1
};
const tabCommonStyle = {
  marginLeft: '10px',
  marginTop: '10px',
  height: '50px',
  width: '210px',
  justifyContent: 'center'
};
const SideMenuButtonItemsWithFn = (userName, type, icon, fn, personaName, userTypeType, isClicked) => [[{
  visibleTo: {
    superadmin: true,
    admin: true,
    twm: true,
    owner: true,
    dispatcher: true,
    manager: true,
    technician: true
  },
  Component: 'HeaderText',
  title: "Welcome, ".concat(userName, "!"),
  variant: "link-text",
  style: {
    ...commonStyle,
    marginRight: '15px'
  },
  mobStyle: commonStyle
}, {
  visibleTo: {
    superadmin: true,
    admin: true,
    twm: true,
    owner: true,
    dispatcher: true,
    manager: true,
    technician: true
  },
  Component: 'Text',
  title: "".concat(personaName),
  variant: "link-text",
  style: {
    marginRight: '15px',
    fontSize: '1em',
    fontWeight: 400,
    lineHeight: '20px',
    width: '200px',
    fontFamily: 'Poppins',
    color: '#9A9A9A',
    left: 0,
    padding: 1,
    marginBottom: "4px"
  },
  mobStyle: commonStyle
}, {
  visibleTo: {
    superadmin: true,
    admin: true,
    twm: true,
    owner: true,
    dispatcher: true,
    manager: true,
    technician: true
  },
  rightIcon: '',
  Component: "Button",
  title: 'Edit Profile',
  variant: "nav-link-button",
  style: {
    fontSize: '13px',
    marginRight: 15
  },
  mobStyle: {
    fontSize: '13px',
    marginRight: 15
  },
  onClick: fn.handleEditProfile
}], [{
  visibleTo: {
    superadmin: false,
    admin: false,
    twm: false,
    owner: !type,
    dispatcher: !type,
    manager: true,
    technician: true
  },
  Component: "Button",
  title: 'Home',
  rightIcon: icon.ArrowRight,
  icon: icon.FaUserFriends,
  variant: "nav-primary",
  style: {},
  onClick: fn.handleDashBoard
}, {
  visibleTo: {
    superadmin: false,
    admin: false,
    twm: false,
    owner: type,
    dispatcher: type,
    manager: false,
    technician: false
  },
  Component: "Button",
  title: "Manage ".concat(userTypeType === 4 ? "Employees" : "Technicians"),
  rightIcon: icon.ArrowRight,
  icon: icon.FaUserFriends,
  variant: "nav-primary",
  style: {
    marginLeft: '10px',
    marginTop: '10px',
    height: '50px',
    width: '210px',
    justifyContent: 'center'
  },
  onClick: fn.handleUserManagment,
  clickedTile: isClicked === '1' ? clickedStyle : notClickedStyle
}, {
  visibleTo: {
    superadmin: false,
    admin: false,
    twm: false,
    owner: type,
    dispatcher: type,
    manager: false,
    technician: false
  },
  Component: "Button",
  title: 'Manage Stores',
  rightIcon: icon.ArrowRight,
  icon: icon.FaStore,
  variant: "nav-primary",
  style: tabCommonStyle,
  onClick: fn.handleStoreManagement,
  clickedTile: isClicked === '2' ? clickedStyle : notClickedStyle
}, {
  visibleTo: {
    superadmin: false,
    admin: false,
    twm: false,
    owner: false,
    dispatcher: false,
    manager: false,
    technician: false
  },
  Component: 'hr',
  tag: '----'
}, {
  visibleTo: {
    superadmin: true,
    admin: true,
    twm: true,
    owner: true,
    dispatcher: true,
    manager: true,
    technician: true
  },
  Component: "Button",
  title: 'Legal',
  rightIcon: icon.ArrowRight,
  icon: icon.FaUserCircle,
  variant: "nav-primary",
  style: tabCommonStyle,
  onClick: fn.legal,
  clickedTile: isClicked === '3' ? clickedStyle : notClickedStyle
}, {
  visibleTo: {
    superadmin: true,
    admin: true,
    twm: true,
    owner: true,
    dispatcher: true,
    manager: true,
    technician: true
  },
  Component: "Button",
  rightIcon: icon.ArrowRight,
  icon: icon.FaUserCircle,
  variant: "nav-primary",
  style: tabCommonStyle,
  title: 'Warranty',
  onClick: fn.warranty,
  clickedTile: isClicked === '4' ? clickedStyle : notClickedStyle
}], [{
  visibleTo: {
    superadmin: true,
    admin: true,
    twm: true,
    owner: true,
    dispatcher: true,
    manager: true,
    technician: true
  },
  Component: "Button",
  title: 'Contact Pentair',
  icon: "",
  rightIcon: icon.ArrowRight,
  variant: "nav-primary",
  style: tabCommonStyle,
  onClick: fn.contactPentair,
  clickedTile: isClicked === '5' ? clickedStyle : notClickedStyle
}, {
  visibleTo: {
    superadmin: true,
    admin: true,
    twm: true,
    owner: true,
    dispatcher: true,
    manager: true,
    technician: true
  },
  Component: "Button",
  title: 'Log Out',
  icon: "",
  rightIcon: icon.ArrowRight,
  variant: "nav-primary",
  onClick: fn.signOut,
  style: {
    marginRight: '10px',
    fontFamily: 'Poppins',
    textAlign: 'left',
    marginTop: '20px',
    color: '#E00932',
    height: '50px',
    width: '210px',
    padding: 1
  }
}]];
exports.SideMenuButtonItemsWithFn = SideMenuButtonItemsWithFn;
const detectCamera = () => {
  console.log(navigator);
  navigator.getMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
  return new Promise((resolve, reject) => {
    navigator.getMedia({
      video: true
    }, function (e) {
      // webcam is available
      const track = e.getTracks()[0];
      console.log('has access');
      // track.stop()
      // resolve(true)
    }, function () {
      console.log('has no access');
      // webcam is not available
      resolve(false);
    });
  });
};
exports.detectCamera = detectCamera;
const getMessageForBrowser = () => {
  const browser = _bowser.default.getParser(window.navigator.userAgent);
  const browserName = browser.getBrowserName();
  console.log("browserName", browserName);
  let message = /*#__PURE__*/_react.default.createElement("span", null, "You need to allow this app to use your camera.  ", /*#__PURE__*/_react.default.createElement("br", null), "To change the camera permissions:", /*#__PURE__*/_react.default.createElement("br", null), " Go to ", /*#__PURE__*/_react.default.createElement("strong", null, "Site settings > Permissions > Camera"));
  switch (browserName) {
    case 'Chrome':
      message = /*#__PURE__*/_react.default.createElement("span", null, "You need to allow this app to use your camera.  ", /*#__PURE__*/_react.default.createElement("br", null), "To change the camera permissions:", /*#__PURE__*/_react.default.createElement("br", null), " Go to ", /*#__PURE__*/_react.default.createElement("strong", null, "Chrome preferences"), " > Click ", /*#__PURE__*/_react.default.createElement("strong", null, "Privacy and security > Site settings > Permissions > Camera"));
      break;
    case 'Microsoft Edge':
      message = /*#__PURE__*/_react.default.createElement("span", null, "You need to allow this app to use your camera.  ", /*#__PURE__*/_react.default.createElement("br", null), "To change the camera permissions:", /*#__PURE__*/_react.default.createElement("br", null), " Go to ", /*#__PURE__*/_react.default.createElement("strong", null, "Microsoft Edge preferences"), " > Click ", /*#__PURE__*/_react.default.createElement("strong", null, "Privacy and security > Site settings > Permissions > Camera"));
      break;
    case 'Safari':
      message = /*#__PURE__*/_react.default.createElement("span", null, "You need to allow this app to use your camera. ", /*#__PURE__*/_react.default.createElement("br", null), "To change the camera permissions:", /*#__PURE__*/_react.default.createElement("br", null), "Go to ", /*#__PURE__*/_react.default.createElement("strong", null, "Safari preferences"), " > Navigate to ", /*#__PURE__*/_react.default.createElement("strong", null, "Websites > Camera"));
      break;
    case 'Firefox':
      message = /*#__PURE__*/_react.default.createElement("span", null, "You need to allow this app to use your camera. ", /*#__PURE__*/_react.default.createElement("br", null), "To change the camera permissions:", /*#__PURE__*/_react.default.createElement("br", null), "Go to ", /*#__PURE__*/_react.default.createElement("strong", null, "Firefox preferences"), " > Click ", /*#__PURE__*/_react.default.createElement("strong", null, "Privacy and security > Permissions > Camera"));
      break;
  }
  return message;
};
/**
 * Based Upon the alert Recieved from the Action Page will be navigated.
 * @param alertCode : recieved from the WS event.
 */
exports.getMessageForBrowser = getMessageForBrowser;
const pageHandleOnAlerts = (alert, dispatch, navigate, userType) => {
  const pageHandle = {
    "GEN_SYSTEM_REMOVED": () => {
      if (!getPlatformType()) {
        if (userType === 4 || userType === 6) {
          navigate(_RoutePath.default.storeDashboard.useLink);
          dispatch((0, _systemsReducer.selectSystems)({}));
        } else {
          navigate(_RoutePath.default.techDispatcher.useLink);
          dispatch((0, _systemsReducer.selectSystems)({}));
        }
      }
    },
    "GEN_CUST_ORG_DELETED": () => {
      navigate(_RoutePath.default.login.useLink);
      localStorage.clear();
    },
    "GEN_SP_ORG_DELETED": () => {
      navigate(_RoutePath.default.login.useLink);
      localStorage.clear();
    },
    "default": () => {
      return true;
    }
  };
  const setter = pageHandle[alert] || pageHandle["default"];
  return setter();
};
const getStoresInfo = async (wssPayload, setWssResponse, setIsAlert, dispatch, stores, generalAlerts, navigate, userType) => {
  const token = (await _awsAmplify.Auth.currentSession()).getAccessToken().getJwtToken();
  const payloadObj = {
    ...wssPayload
  };
  payloadObj.request.token = token;
  const obj = {
    ...payloadObj,
    request: JSON.stringify(payloadObj.request)
  };
  try {
    if (!_WebSocketManager.default.getIsConnect()) {
      _WebSocketManager.default.getInstance().connect().sendEvent(obj);
      _event.eventEmitter.subscribe("socketOnMessage", data => {
        var _data$alert;
        pageHandleOnAlerts(data === null || data === void 0 ? void 0 : (_data$alert = data.alert) === null || _data$alert === void 0 ? void 0 : _data$alert.alarmCode, dispatch, navigate, userType);
        if (data.eventType === "PRODUCT") {
          setWssResponse(data);
          setIsAlert(true);
        } else if (data.eventType === "SYSTEM") {
          setWssResponse(data);
          setIsAlert(true);
        } else if (data.eventType === "GENERAL") {
          var _data$alert2, _data$alert3, _data$alert4;
          setWssResponse(data);
          if ((data === null || data === void 0 ? void 0 : (_data$alert2 = data.alert) === null || _data$alert2 === void 0 ? void 0 : _data$alert2.deviceId) === "GENERAL" && data !== null && data !== void 0 && (_data$alert3 = data.alert) !== null && _data$alert3 !== void 0 && _data$alert3.storeId && !(data !== null && data !== void 0 && (_data$alert4 = data.alert) !== null && _data$alert4 !== void 0 && _data$alert4.shouldNotMapStore)) {
            var _data$alert5;
            (0, _Services.getStoreDetails)(data === null || data === void 0 ? void 0 : (_data$alert5 = data.alert) === null || _data$alert5 === void 0 ? void 0 : _data$alert5.storeId).then(store => {
              dispatch((0, _storesReducer.storesInfo)([...stores, store === null || store === void 0 ? void 0 : store.data]));
            });
          }
          dispatch((0, _alertReducer.generalAlertData)([data === null || data === void 0 ? void 0 : data.alert, ...generalAlerts]));
          setIsAlert(true);
        } else {
          setIsAlert(false);
        }
      });
    }
  } catch (error) {
    console.log(error);
  }
};
exports.getStoresInfo = getStoresInfo;
const setNotifyPref = (userDetails, setIsAlert) => {
  var _userDetails$UserNoti;
  (userDetails === null || userDetails === void 0 ? void 0 : userDetails.UserNotifyPref) && setIsAlert(userDetails !== null && userDetails !== void 0 && (_userDetails$UserNoti = userDetails.UserNotifyPref) !== null && _userDetails$UserNoti !== void 0 && _userDetails$UserNoti.isNotifyIconClicked ? false : true);
  return () => {};
};
exports.setNotifyPref = setNotifyPref;
const setStoreAndGateway = (wssResponse, gateways, dispatch) => {
  var _wssResponse$alert;
  if (wssResponse !== null && wssResponse !== void 0 && (_wssResponse$alert = wssResponse.alert) !== null && _wssResponse$alert !== void 0 && _wssResponse$alert.deviceId) {
    const newGateways = [...gateways].map(gateway => {
      if (+gateway.deviceId === +wssResponse.alert.deviceId) {
        gateway = {
          ...gateway,
          online: wssResponse.alert.snapshot.device_connected.value === "1" ? true : false
        };
      }
      return gateway;
    });
    getStoreListItems(dispatch, _storesReducer.storesInfo);
    dispatch((0, _gatewayReducer.gatewayInfo)(newGateways));
  }
  return () => {};
};
exports.setStoreAndGateway = setStoreAndGateway;
const setUserDetails = (loginUserInfo, dispatch, roleId, user) => {
  var _user$attributes, _user$attributes2;
  let orgID = null;
  let serachUserType = null;
  switch (roleId) {
    case 4:
    case 6:
      orgID = user === null || user === void 0 ? void 0 : (_user$attributes = user.attributes) === null || _user$attributes === void 0 ? void 0 : _user$attributes['custom:organization_id'];
      serachUserType = 6;
      break;
    case 5:
    case 7:
      orgID = user === null || user === void 0 ? void 0 : (_user$attributes2 = user.attributes) === null || _user$attributes2 === void 0 ? void 0 : _user$attributes2['custom:sp_id'];
      serachUserType = 7;
      break;
    default:
      break;
  }
  dispatch(loginUserInfo({
    email: user.attributes.email,
    challengeName: user.challengeName,
    poolId: user.pool.userPoolId,
    username: user.username,
    userType: roleId,
    orgID,
    serachUserType,
    firstName: user === null || user === void 0 ? void 0 : user.attributes.given_name
  }));
};
exports.setUserDetails = setUserDetails;
const getSystemsData = (selectedStore, dispatch, navigate, setStoreAlertCount, systemsLoading, gatewayLoading, setIsLoading, store, userType) => {
  _event.eventEmitter.subscribe("socketOnMessage", data => {
    if (data.eventType === "PRODUCT") {
      if ((selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.storeId) === (data === null || data === void 0 ? void 0 : data.alert.storeId)) (0, _Services.getStoreDetails)(data === null || data === void 0 ? void 0 : data.alert.storeId).then(store => {
        fetchStoreSystem(data === null || data === void 0 ? void 0 : data.alert.storeId, store, dispatch, setStoreAlertCount);
      });
    }
  });
  dispatch(systemsLoading());
  dispatch(gatewayLoading());
  if (selectedStore !== null && selectedStore !== void 0 && selectedStore.storeId) {
    setIsLoading(true);
    fetchStoreSystem(selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.storeId, store, dispatch, setStoreAlertCount, userType).then(el => {
      setIsLoading(false);
      dispatch(systemsLoading(false));
      dispatch(gatewayLoading(false));
    }).catch(e => {
      setIsLoading(false);
      dispatch(systemsLoading(false));
      dispatch(gatewayLoading(false));
    });
  } else {
    navigate(_RoutePath.default.admin.useLink);
  }
  return null;
};
exports.getSystemsData = getSystemsData;
const handleSensorTimeout = timeOutRef => {
  setTimeout(() => {
    var _timeOutRef$current;
    return timeOutRef === null || timeOutRef === void 0 ? void 0 : (_timeOutRef$current = timeOutRef.current) === null || _timeOutRef$current === void 0 ? void 0 : _timeOutRef$current.onTimeout();
  }, 300000);
};
exports.handleSensorTimeout = handleSensorTimeout;
const removeSystem = async (setIsLoading, systemId, timeOutRef, setSensorEstablished, navigate, setOpenErrorModal, deleteSysId, systemstate) => {
  setIsLoading(true);
  const token = (await _awsAmplify.Auth.currentSession()).getAccessToken().getJwtToken();
  const obj = {
    action: "readRequest",
    request: JSON.stringify({
      name: "remove_system",
      systemId: systemId,
      token: token
    })
  };
  handleSensorTimeout(timeOutRef);
  _WebSocketManager.default.getInstance().connect().sendEvent(obj);
  _event.eventEmitter.subscribe("socketOnMessage", data => {
    if (data.response.data.payload.status === "success") {
      setSensorEstablished(true);
      _WebSocketManager.default.getInstance().connect().sendEvent({});
      isObject(deleteSysId) ? setDeleteSystemState(deleteSysId, setIsLoading, navigate, systemstate) : navigate(_RoutePath.default.techDispatcher.useLink);
    } else if (data.response.data.payload.status === "error") {
      setIsLoading(false);
      setSensorEstablished(false);
      setOpenErrorModal(true);
    }
    _WebSocketManager.default.getInstance().connect().sendEvent({});
    return true;
  });
};
exports.removeSystem = removeSystem;
const setDeleteSystemState = (deleteSysId, setIsLoading, navigate, systemstate) => {
  deleteSysId.current = null;
  getSystemsData(systemstate.selectedStore, systemstate.dispatch, navigate, systemstate.setStoreAlertCount, systemstate.systemsLoading, systemstate.gatewayLoading, setIsLoading, systemstate.store);
  setIsLoading(true);
  return true;
};
exports.setDeleteSystemState = setDeleteSystemState;
const isObject = objValue => {
  return objValue && typeof objValue === 'object' && objValue.constructor === Object;
};
exports.isObject = isObject;
const convertToBase64 = async file => {
  try {
    return await new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = error => {
        reject(error);
      };
    });
  } catch (error) {
    console.log(error, "convertToBase64 error");
  }
};
/**
 * Modular Function to generate UUID : length = 36
 * @returns uuid strings.
 */
exports.convertToBase64 = convertToBase64;
const generateUuid = () => {
  return uuidv4();
};
/**Below Two Functions is to Fetch Image Binary Data from
 * s3 and convert it to blob to set local blob Url.
 * @param {*} b64Data 
 * @param {*} contentType 
 * @param {*} sliceSize 
 * @returns 
 */
exports.generateUuid = generateUuid;
const b64toBlob = function (b64Data) {
  let contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  let sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
  const byteCharacters = atob(b64Data);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, {
    type: contentType
  });
  return blob;
};
const fetchImage = async (imageSubPath, setIsLoading, setImage) => {
  const resp = await (0, _Services.storeImageDownload)(imageSubPath);
  if (JSON.parse(JSON.stringify(resp)).name === "Error") {
    setImage("");
  } else {
    const blobData = b64toBlob(atob(resp).split(',')[1].slice(0, -1));
    const res = URL.createObjectURL(blobData);
    setImage(res);
  }
  setIsLoading(false);
};
exports.fetchImage = fetchImage;
const groupByDate = items => {
  return items.reduce((acc, item) => {
    const date = item.serviceLogsType;
    if (acc[date]) {
      acc[date].push(item);
    } else {
      acc[date] = [item];
    }
    return acc;
  }, {});
};
exports.groupByDate = groupByDate;
const sortObj = obj => {
  let mykeys = Object.keys(obj).sort((a, b) => obj[b].length - obj[a].length);
  let newArr = [];
  mykeys.forEach(key => {
    newArr.push({
      [key]: obj[key]
    });
  });
  return newArr;
};
exports.sortObj = sortObj;
const sortAlphaNumericArray = arr => {
  return arr.sort((a, b) => b.localeCompare(a, undefined, {
    numeric: true,
    senstivity: "base"
  }));
};
exports.sortAlphaNumericArray = sortAlphaNumericArray;
const extractNumberFromString = str => {
  const match = str.match(/\d+/);
  return match ? parseInt(match[0], 10) : null;
};
exports.extractNumberFromString = extractNumberFromString;
const waterInfoMap = () => {
  const waterDetailsMap = new Map();
  Object.keys(_strings2.waterInfoValue).forEach(reading => {
    waterDetailsMap.set(reading);
  });
  return waterDetailsMap;
};
exports.waterInfoMap = waterInfoMap;
const SERVICE_LOGS_TYPE = exports.SERVICE_LOGS_TYPE = {
  SYSTEM_ADDED: "1",
  SYSTEM_UPDATED: "2",
  WATER_DEST_UPDATED: "3",
  REPLACEMENT_PART_UPDATED: "4",
  ACCESSORY_ADDED: "5",
  ACCESSORY_UPDATED: "6",
  WATER_DETAILS_UPDATED: "7",
  IMAGES_UPDATED: "8"
};
const isTimeDifference24Hours = (date1, date2) => {
  const diffMilliSec = new Date(date2) - new Date(date1);
  const hoursPassed = diffMilliSec / (1000 * 60 * 60);
  return hoursPassed >= 24;
};
exports.isTimeDifference24Hours = isTimeDifference24Hours;
const groupLogs = items => {
  return items === null || items === void 0 ? void 0 : items.reduce((data, item) => {
    var _item$createdBy, _item$createdBy2;
    const name = (item === null || item === void 0 ? void 0 : (_item$createdBy = item.createdBy) === null || _item$createdBy === void 0 ? void 0 : _item$createdBy.firstName) + (item === null || item === void 0 ? void 0 : (_item$createdBy2 = item.createdBy) === null || _item$createdBy2 === void 0 ? void 0 : _item$createdBy2.lastName);
    if (data[name]) {
      data[name].push(item);
    } else {
      data[name] = [item];
    }
    return data;
  }, {});
};
exports.groupLogs = groupLogs;
const groupData = items => {
  return items === null || items === void 0 ? void 0 : items.reduce((data, item) => {
    var _item$SystemReference, _item$SystemReference2, _item$SystemReference3;
    const name = (item === null || item === void 0 ? void 0 : (_item$SystemReference = item.SystemReferenceMapping) === null || _item$SystemReference === void 0 ? void 0 : _item$SystemReference.refAppType) === 'Replacement Part' ? (item === null || item === void 0 ? void 0 : (_item$SystemReference2 = item.SystemReferenceMapping) === null || _item$SystemReference2 === void 0 ? void 0 : _item$SystemReference2.refAppName) + " { " + "".concat(item === null || item === void 0 ? void 0 : (_item$SystemReference3 = item.SystemReferenceMapping) === null || _item$SystemReference3 === void 0 ? void 0 : _item$SystemReference3.refAppModelNumber) + " }" : item === null || item === void 0 ? void 0 : item.createdAt;
    if (data[name]) {
      var _data$name;
      (_data$name = data[name]) === null || _data$name === void 0 ? void 0 : _data$name.push(item);
    } else {
      data[name] = [item];
    }
    return data;
  }, {});
};
exports.groupData = groupData;